import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProjectMapView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2 15L4 11H5.5L4.5 13.5H13.5L12.5 11H14L16 15H2Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 2.25C9.95 2.25 10.7877 2.58164 11.5127 3.24414C12.2374 3.90654 12.5995 4.8062 12.5996 5.94336C12.5996 6.85582 12.2437 7.75609 11.5312 8.64355C10.8188 9.53105 10.1434 10.2559 9.50586 10.8184C9.43095 10.8808 9.35007 10.9277 9.2627 10.959C9.1752 10.9902 9.0875 11.0059 9 11.0059C8.9125 11.0059 8.8248 10.9902 8.7373 10.959C8.64993 10.9277 8.56904 10.8808 8.49414 10.8184C7.85664 10.2559 7.18125 9.53105 6.46875 8.64355C5.75631 7.75609 5.40039 6.85582 5.40039 5.94336C5.40047 4.8062 5.76259 3.90654 6.4873 3.24414C7.2123 2.58164 8.05 2.25 9 2.25ZM9 4.5C8.17157 4.5 7.5 5.17157 7.5 6C7.5 6.82843 8.17157 7.5 9 7.5C9.82843 7.5 10.5 6.82843 10.5 6C10.5 5.17157 9.82843 4.5 9 4.5Z",
		fill: "currentColor"
	})]
});
export default SvgProjectMapView;
